<template>
  <v-card :class="margin">
    <alert-header-panel :panel-type="panelType"
                        :panel-colour="panelColour"
                        :checkbox-value="frequencyCheckbox"
                        @set-checkbox="setAllFrequency"
                        :checkbox-id="frequencyCheckboxId"/>
    <v-divider/>
    <v-container>
      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <p>{{$t('admin.alerts.new.frequency.email_frequency')}}</p>
        </v-flex>
        <v-flex v-for="(frequency, key) in frequencies" :key="key" xs1>
          {{frequency.name}}
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-space-between>
        <v-flex v-for="(frequency, key) in frequencies" :key="key" xs1>
          <v-checkbox :id="frequencyId(frequency.name)" :aria-label="frequencyId(frequency.name)" role="checkbox" v-model="frequencyItems" :value="frequency.id"></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <v-text-field v-model="consecutiveDays"
                        id="alert-consecutive-days"
                        aria-label="alert-consecutive-days"
                        :label="$t('admin.alerts.new.alert_frequency')"
                        required
                        :rules="consecutiveDaysRule" :mask="numberMask">
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  import AlertHeaderPanel from './AlertHeaderPanel'
  import { SELECT_ALL_FREQUENCY, SELECT_FREQUENCY_ITEMS, SET_ALERT_CONSECUTIVE_DAYS } from '../../../store/mutation-types'
  import { EDIT_ALERT_DETAILS } from '../../../store/action-types'

  export default {
    name: 'alert-frequency',
    components: {AlertHeaderPanel},
    data () {
      return {
        frequencies: [{
          id: '2',
          name: 'Mon'
        }, {
          id: '3',
          name: 'Tue'
        }, {
          id: '4',
          name: 'Wed'
        }, {
          id: '5',
          name: 'Thu'
        }, {
          id: '6',
          name: 'Fri'
        }, {
          id: '7',
          name: 'Sat'
        }, {
          id: '1',
          name: 'Sun'
        }],
        consecutiveDaysRule: [v => !!v || this.$t('field_required'), v => v > 0 || this.$t('admin.alerts.new.consecutive_days_rule')],
        frequencyValues: ['1', '2', '3', '4', '5', '6', '7'],
        panelType: {
          title: 'admin.alerts.new.frequency.title',
          info: 'admin.alerts.new.frequency.info'
        },
        numberMask: '###'
      }
    },
    props: {
      panelColour: {},
      margin: {}
    },
    methods: {
      frequencyId (name) {
        return `frequency-${name.toLowerCase()}`
      },
      setAllFrequency (value) {
        this.$store.commit(SELECT_ALL_FREQUENCY, value)
        this.$store.dispatch(EDIT_ALERT_DETAILS, {alertId: this.$store.state.admin.newSingleAlert.id, alert: this.$store.state.admin.newSingleAlert})
      }
    },
    computed: {
      frequencyCheckbox () {
        return this.frequencyItems ? this.frequencyItems.length === this.frequencyValues.length : false
      },
      frequencyItems: {
        get () {
          return this.$store.state.admin.newSingleAlert.frequencyDays
        },
        set (val) {
          this.$store.commit(SELECT_FREQUENCY_ITEMS, val)
          this.$store.dispatch(EDIT_ALERT_DETAILS, {alertId: this.$store.state.admin.newSingleAlert.id, alert: this.$store.state.admin.newSingleAlert})
        }
      },
      consecutiveDays: {
        get () {
          return this.$store.state.admin.newSingleAlert.consecutiveDays
        },
        set (val) {
          if (val) {
            this.$store.commit(SET_ALERT_CONSECUTIVE_DAYS, val)
            this.$store.dispatch(EDIT_ALERT_DETAILS, {alertId: this.$store.state.admin.newSingleAlert.id, alert: this.$store.state.admin.newSingleAlert})
          }
        }
      },
      frequencyCheckboxId () {
        return 'check-all-frequency'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFrequency.vue